<template>
    <div class="email"><v-icon size="18px">email</v-icon>{{email}}</div>
</template>


<script>

export default {
  components: { },
  props: { email: String },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
  },
  created() {
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .email {
        @include font-size(16px);
        width: fit-content;
        line-height: 20px;

        .v-icon {
            margin-right: 10px;
        }
    }
</style>